import { render } from "./cardBoxData.vue?vue&type=template&id=87e5897c"
import script from "./cardBoxData.vue?vue&type=script&lang=js"
export * from "./cardBoxData.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__